module.exports = __webpack_public_path__ + "static/media/tela5.af58c7a7.png";